import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-6c77cbfd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-nav"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = {
  class: "footer-r"
};
const _hoisted_4 = {
  class: "nav-list"
};
const _hoisted_5 = {
  class: "nav-title"
};
const _hoisted_6 = {
  class: "nav-list"
};
const _hoisted_7 = {
  class: "nav-title"
};
const _hoisted_8 = {
  class: "nav-list"
};
const _hoisted_9 = {
  class: "nav-title"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-item"
}, "Email：support@ftzcoininc.com", -1));
const _hoisted_11 = {
  class: "nav-list"
};
const _hoisted_12 = {
  class: "nav-title"
};
const _hoisted_13 = {
  class: "nav-list"
};
const _hoisted_14 = {
  class: "footer-tip"
};
const _hoisted_15 = {
  class: "left"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_17 = {
  class: "content"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CopyRight © 2026 FTZINC. All Rights Reserved.", -1));
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"center\" data-v-6c77cbfd></div><div class=\"right\" data-v-6c77cbfd><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-linkedin-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M3.493 8.21c0-.879.56-.742 1.337-.742.776 0 1.325-.137 1.325.743v8.565c0 .891-.56.709-1.325.709-.765 0-1.337.182-1.337-.709V8.211ZM5.886 5.031c.278-.286.432-.67.428-1.07A1.52 1.52 0 0 0 4.83 2.5a1.53 1.53 0 0 0-1.497 1.462 1.553 1.553 0 0 0 1.497 1.53 1.52 1.52 0 0 0 1.056-.46ZM8.439 8.21c0-.49.183-.673.468-.73.286-.058 1.268 0 1.61 0 .343 0 .48.56.469.982a2.866 2.866 0 0 1 2.558-1.142 3.427 3.427 0 0 1 3.632 3.575v5.847c0 .891-.548.708-1.325.708-.776 0-1.325.183-1.325-.708v-4.568a1.646 1.646 0 0 0-1.736-1.782 1.657 1.657 0 0 0-1.69 1.816v4.568c0 .891-.56.709-1.336.709-.777 0-1.325.182-1.325-.709V8.211Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-x-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"m16.196 3.333-5.279 5.66m-7.112 7.628 5.274-5.656m4.268 5.656L3.333 3.333h3.32l10.014 13.288h-3.32Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-facebook-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M7.986 18.089v-5.542h-1.72V10h1.72V8.903c0-2.837 1.284-4.15 4.067-4.15.527 0 1.436.103 1.81.207v2.306c-.197-.02-.54-.03-.963-.03-1.367 0-1.894.517-1.894 1.864v.9h2.724l-.467 2.546H11.01v5.727M18.333 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-instagram-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M10 13.281a3.281 3.281 0 1 0 0-6.562 3.281 3.281 0 0 0 0 6.562Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path><path d=\"M13.75 2.5h-7.5A3.75 3.75 0 0 0 2.5 6.25v7.5a3.75 3.75 0 0 0 3.75 3.75h7.5a3.75 3.75 0 0 0 3.75-3.75v-7.5a3.75 3.75 0 0 0-3.75-3.75Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path><path clip-rule=\"evenodd\" d=\"m14.13 5.838-.005.004-.004-.004.004-.005.004.005Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-youtube-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M7.833 13.359V7.974a.5.5 0 0 1 .77-.436l4.615 2.692a.513.513 0 0 1 0 .885l-4.615 2.692a.512.512 0 0 1-.77-.448Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path><path d=\"M15.77 3.333H4.23a2.564 2.564 0 0 0-2.564 2.564v8.974a2.564 2.564 0 0 0 2.565 2.565h11.538a2.564 2.564 0 0 0 2.564-2.565V5.897a2.564 2.564 0 0 0-2.564-2.564Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-coinmarketcap-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"m3.3 14.96 4.92-7.774c.247-.392.854-.216.854.248v4.138c0 .916 1.188 1.276 1.696.513l3.011-4.516a.463.463 0 0 1 .848.257v3.47c0 .819.664 1.482 1.482 1.482 1.04 0 1.914-.715 2.156-1.68M18.333 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-coingecko-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M3.43 15.127c1.752-3.627.709-8.322 3.534-9.06 2.826-.74 4.673.521 6.151.956 1.478.434 2.705.665 2.978 2.043.39 1.977-6.073 5.36-4.707 9.153m0 .003v-.003m-1.248-7.067c1.238.978 2.517.653 5.347-.532m-3.218-3.9c0-.881-1.608-1.588-2.604-.806m1.723 12.305A8.333 8.333 0 1 0 8.614 1.782a8.333 8.333 0 0 0 2.772 16.437Zm-1.248-9.65a1.282 1.282 0 1 1-2.565 0 1.282 1.282 0 0 1 2.564 0Zm3.991.602-.004.004-.004-.004.004-.004.004.004Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div><div class=\"item\" data-v-6c77cbfd><svg fill=\"none\" viewBox=\"0 0 20 20\" id=\"logo-telegram-outline\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6c77cbfd><path d=\"M1.877 9.456a.331.331 0 0 0-.21.306c0 .132.087.257.21.304l3.882 1.416 7.998-4.128a.2.2 0 0 1 .247.065.2.2 0 0 1-.029.253l-5.74 5.06 6.389 4.623a.334.334 0 0 0 .304.042.329.329 0 0 0 .202-.23l3.195-13.434a.33.33 0 0 0-.102-.32.33.33 0 0 0-.33-.06L1.877 9.456Z\" stroke=\"#fff\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6c77cbfd></path></svg></div></div>", 2);
import { ref, watch, onBeforeUnmount } from 'vue';
import router from '@/router';
import store from '@/store';
import CusomDownload from '@/components/home/CusomDownload.vue';
import { getArticle } from '@/apis';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'FooterNav',
  setup(__props) {
    const {
      t
    } = useI18n();
    const agreeList = ref([]);
    const init = async () => {
      const res = await getArticle({
        type: 4
      });
      if (res.code === 200 && res.data && res.data.data) {
        agreeList.value = res.data.data?.list?.map(item => {
          return {
            id: item.article_id,
            title: item.article_title,
            time: item.article_create_time
          };
        });
      }
    };

    // const langSelcet = (lang) => {
    //   try {
    //     localStorage.setItem('pcsetlang', lang)
    //     store.commit('langChange', lang)
    //     const msg = require(`@/language/lang/${lang}`).default
    //     setLocaleMessage(lang, msg)
    //     locale.value = lang
    //   } catch (err) {
    //     console.warn(err)
    //   }
    // }

    const langWatch = watch(() => store.state.lang, init);
    const time = ref('');
    setInterval(() => {
      time.value = new Date().toLocaleString('ja', {
        timeZone: 'America/New_York'
      }).replace(/\//g, '-');
    }, 1000);
    onBeforeUnmount(() => {
      langWatch();
    });
    const download = () => {
      //网页链接合成
      let address = '';
      let arr = window.location.host.split('.');
      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }
      window.open('https://' + address + '/FTZINC.apk');
    };
    const download1 = () => {
      //网页链接合成
      let address = '';
      let arr = window.location.host.split('.');
      if (arr.length == 3 && arr[0] == 'pc') {
        address = arr[1] + '.' + arr[2];
      } else if (arr.length == 3 && arr[0] == 'www') {
        address = arr[1] + '.' + arr[2];
      } else {
        address = arr[0] + '.' + arr[1];
      }
      window.open('https://' + address + '/download/FTZCOIN.mobileconfig');
      // window.location.href = 'https://apps.apple.com/us/app/ftzc/id6759857278';
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('userAgree')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push(`/article/usersagreements`))
      }, _toDisplayString(_unref(t)('usersAgreementsTitle')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push(`/article/privacypolicy`))
      }, _toDisplayString(_unref(t)('privacyPolicyTitle')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push(`/article/legalstatement`))
      }, _toDisplayString(_unref(t)('legalStatementTitle')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push(`/article/launderingpolicy`))
      }, _toDisplayString(_unref(t)('launderingPolicyTitle')), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('aboutUs')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push(`/article/aboutus`))
      }, _toDisplayString(_unref(t)('aboutName')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'notice'
        }))
      }, _toDisplayString(_unref(t)('bulletin')), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('contact')), 1), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('appDownload')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: download
      }, _toDisplayString(_unref(t)('androidDownload')), 1), _createElementVNode("a", {
        class: "nav-item",
        onClick: download1
      }, _toDisplayString(_unref(t)('iosDownload')), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(CusomDownload, {
        type: 1
      })])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", null, _toDisplayString(_unref(t)('footerBottomTip')), 1)])]), _hoisted_19])]);
    };
  }
};